export default function AssetTypeController(
  $rootScope,
  $scope,
  confirmDialog,
  editAssetTypeDialog,
  // syncAssetTypeConfirmDialog,
  copyAssetTypeDialog,  
  deleteAssetTypeConfirmDialog,
  loaderService,
  assetDataService,
  assetSharedModelService,
  riskSharedModelService,
  ssDialogService
) {
  const vm = this;

  vm.canExpand = true;
  vm.assetType.isExpanded = false;
  vm.hasData = false;

  vm.handleExpandClick = _handleExpandClick;

  vm.handleEditClick = _handleEditClick;
  vm.handleSyncClick = _handleSyncClick;
  vm.handleCopyClick = _handleCopyClick;
  vm.handleDeleteClick = _handleDeleteClick;

  _activate();

  function _activate() {
    if (vm.assignAsset === true) {
      vm.tooltipAppendToSelector = '#assignAssetDialog';
    }
    initEventListeners();
    _initTooltips();
    _initCriticality();
    _initRiskTypeSeverity();
    _initRiskTypeProbability();
  }

  function initEventListeners() {
    $scope.$on('refreshAssetType', (event, opt) => {
      if (opt.assetType.customerAssetTypeId === vm.assetType.customerAssetTypeId) {
        loaderService.showViewLoader = true;
        assetDataService.getAssetType(vm.assetType.customerAssetTypeId).then((getAssetTypeResponse) => {
          const newAssetType = _initRiskSeverities(getAssetTypeResponse.data);
          vm.assetType = {
            ...vm.assetType,
            ...newAssetType,
          };
          _initCriticality();
          vm.hasData = true;
        }).finally(() => {
          loaderService.showViewLoader = false;
        });
      }
    });

    $scope.$on('refreshTopRiskTypes', (event, opt) => {
      if (opt.assetType.customerAssetTypeId === vm.assetType.customerAssetTypeId) {
        vm.assetType.customerRiskTypes = vm.assetType.customerRiskTypes || [];
        vm.assetType.customerRiskTypes = opt.assetType.customerRiskTypes;
      }
      // if (opt.assetType.customerAssetTypeId === vm.newAssetType.customerAssetTypeId) {
      //   loaderService.showViewLoader = true;
      //   _getAssignedRisks().then(() => {
      //     loaderService.showViewLoader = false;
      //   });
      // }
    });

    $scope.$on('pra_risk-type-updated', (event, opt) => {
      if (vm.assetType.customerRiskTypes && vm.assetType.customerRiskTypes.length > 0) {
        // eslint-disable-next-line max-len
        const pos = vm.assetType.customerRiskTypes.findIndex(item => item.customerRiskTypeId === opt.riskType.customerRiskTypeId);
        if (pos === -1) return; // Can't find the item
        vm.assetType.customerRiskTypes[pos] = opt.riskType;
      }
    });

    $scope.$on('pra_risk-type-deleted', (event, payload) => {
      if (payload.assetType && payload.assetType.customerAssetTypeId === vm.assetType.customerAssetTypeId) {
        if (vm.assetType.customerRiskTypes && vm.assetType.customerRiskTypes.length > 0) {
          vm.assetType.customerRiskTypes = vm.assetType.customerRiskTypes.filter(
            riskType => riskType.customerRiskTypeId !== payload.riskType.customerRiskTypeId
          );
        }
      }
    });

    $scope.$on('refreshAssetTypes', _refreshAssetTypes);
  }

  function _refreshAssetTypes() {
    vm.assetType.isExpanded = false;
    vm.hasData = false;
  }

  function _initTooltips() {
    vm.assetType.assetDataTypeTooltip = 'This is ';
    switch (vm.assetType.assetDataTypeId) {
      case 1:
        vm.assetType.assetDataTypeTooltip += ' a Physical Asset.';
        break;
      case 2:
        vm.assetType.assetDataTypeTooltip += ' an Electronic Asset.';
        break;
      case 3:
        vm.assetType.assetDataTypeTooltip += ' both a Physical and Electronic Asset.';
        break;
      default:
        vm.assetType.assetDataTypeTooltip = null;
    }
  }

  function _initCriticality() {
    if (vm.assetType.assetCriticalityId) {
      const classMappings = {
        1: 'status-tier-bar--terrible',
        2: 'status-tier-bar--bad',
        3: 'status-tier-bar--caution',
        4: 'status-tier-bar--good',
        5: 'status-tier-bar--great',
      };
      vm.assetType.criticalityCssClass = classMappings[vm.assetType.assetCriticalityId];
      if (!vm.assetType.assetCriticality) {
        vm.assetType.assetCriticality = assetSharedModelService.AssetCriticalities.find(
          assetCriticality => assetCriticality.assetCriticalityId === vm.assetType.assetCriticalityId
        );
      }
    }
  }

  function _initRiskTypeProbability() {
    if (vm.assetType.customerAssetCustomerRisks) {
      vm.assetType.customerAssetCustomerRisks = assetSharedModelService.addProbabilityCssClassesToRiskTypes(
        vm.assetType.customerAssetCustomerRisks
      );
    }
  }

  function _initRiskTypeSeverity() {
    if (vm.assetType.customerAssetCustomerRisks) {
      vm.assetType.customerAssetCustomerRisks = assetSharedModelService.addSeverityDescriptionsToRisks(
        vm.assetType.customerAssetCustomerRisks
      );
    }
  }

  function _handleEditClick($event) {
    loaderService.showViewLoader = true;
    assetDataService.getAssetType(vm.assetType.customerAssetTypeId).then((getAssetTypeResponse) => {
      ssDialogService.dialogs.assetAdmin.editAssetTypeDialog = ssDialogService.alert(
        editAssetTypeDialog.getOptions($event, {
          assetType: getAssetTypeResponse.data,
          assetCriticalities: assetSharedModelService.AssetCriticalities,
          assetDataTypes: assetSharedModelService.AssetDataTypes,
          assetDataUses: assetSharedModelService.AssetDataUses,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.assetAdmin.editAssetTypeDialog);
      loaderService.showViewLoader = false;
    });
  }

  function _handleSyncClick($event) {
    ssDialogService.dialogs.ent.confirmSyncAssetTypeDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Confirm Synchronize Asset Type to Master Asset Type?',
        warningMessage: "You are about to synchronize the Asset Type to the default values associated with the Master Asset Type.\r\nAny changes you have made will be lost.", 
        message: `Are you sure you want to synchronize this Asset Type to the default values?`, 
        handleYesClick: _performSynchronizeAssetType,
        handleNoClick: _closeConfirmSynchronizeAssetType,
        updateCallBack: _broadcastEvents,
      }),
    );

    ssDialogService.show(ssDialogService.dialogs.ent.confirmSyncAssetTypeDialog);
  }

  function _performSynchronizeAssetType($event) {
    loaderService.showViewLoader = true;

   assetDataService.syncAssetTypeWithMaster(vm.assetType.customerAssetTypeId).then((result) => {
      if (result.data) {
        // ssDialogService.hide(ssDialogService.dialogs.ent.confirmSyncAssetTypeDialog);
        $rootScope.$broadcast('refreshAssetTypes');
        alerts.success('Sync with the Master Asset Type was successful.');
      } else {
        alerts.error('Error occurred synchronizing with the Master Asset Type.');
      }
    }, () => {
      alerts.error('Error occurred synchronizing with the Master Asset Type.');
    }).finally(() => {
      _closeConfirmSynchronizeAssetType();
      // loaderService.showViewLoader = false;
    });
  }

  function _closeConfirmSynchronizeAssetType() {
    ssDialogService.hide(ssDialogService.dialogs.ent.confirmSyncAssetTypeDialog);
  }

  function _handleCopyClick($event) {
    loaderService.showViewLoader = true;
    assetDataService.getAssetType(vm.assetType.customerAssetTypeId).then((response) => {
      ssDialogService.dialogs.assetAdmin.copyAssetTypeDialog = ssDialogService.alert(
        copyAssetTypeDialog.getOptions($event, {
          assetType: response.data,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.assetAdmin.copyAssetTypeDialog);
      loaderService.showViewLoader = false;
    });
  }

  function _handleDeleteClick($event) {
    ssDialogService.dialogs.assetAdmin.deleteAssetTypeDialog = ssDialogService.alert(
      deleteAssetTypeConfirmDialog.getOptions($event, {
        //customerId: endnote.customerId,
        assetType: vm.assetType,
        updateCallBack: _broadcastEvents,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.assetAdmin.deleteAssetTypeDialog);
  }

  function _broadcastEvents() {
    // if (vm.isEditProcessDialog === true) {
    //   $rootScope.$broadcast('refreshAssessmentAssets', { assetType: vm.assetType });
    // } else if (vm.assignAsset === true) {
    //   $rootScope.$broadcast('refreshAssignAssets');
    // } else if (vm.isPraProcessMain === true) {
    //   $rootScope.$broadcast('refreshMainAssessmentProcess', { process: vm.process });
    // } else {
      $rootScope.$broadcast('refreshAssetTypes');
      $rootScope.$broadcast('refreshAssets', { assetType: vm.assetType });
    // }
  }
  
  function _handleExpandClick() {
    if (!vm.assetType.isExpanded) {
      assetDataService.getAssetType(vm.assetType.customerAssetTypeId).then((getAssetTypeResponse) => {
        const newAssetType = _initRiskSeverities(getAssetTypeResponse.data);
        vm.assetType = {
          ...vm.assetType,
          ...newAssetType,
        };
        vm.hasData = true;
      });
    }
    vm.assetType.isExpanded = !vm.assetType.isExpanded;
  }

  function _initRiskSeverities(assetType) {
    assetType.customerRiskTypes.map((riskType) => {
      riskSharedModelService.addSeverityDescriptionsToRiskType(riskType);
      riskSharedModelService.transformMeterStatusToRiskType(riskType);
      riskSharedModelService.addColorToProbability(riskType);
      return riskType;
    });
    return assetType;
  }
}

AssetTypeController.$inject = [
  '$rootScope',
  '$scope',
  'confirmDialog',
  'editAssetTypeDialog',
  // 'syncAssetTypeConfirmDialog',
  'copyAssetTypeDialog',  
  'deleteAssetTypeConfirmDialog',
  'loaderService',
  'assetDataService',
  'assetSharedModelService',
  'riskSharedModelService',
  'ssDialogService'
];
